var render = function () {
  var _vm$currentStep, _vm$currentStep$activ, _vm$currentStep$activ2, _vm$currentStep2, _vm$currentStep2$acti, _vm$currentStep2$acti2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', [_c('figure', [(_vm$currentStep = _vm.currentStep) !== null && _vm$currentStep !== void 0 && (_vm$currentStep$activ = _vm$currentStep.activityImage) !== null && _vm$currentStep$activ !== void 0 && (_vm$currentStep$activ2 = _vm$currentStep$activ.image) !== null && _vm$currentStep$activ2 !== void 0 && _vm$currentStep$activ2.src ? _c('img', {
    attrs: {
      "alt": _vm.currentStep.answer,
      "src": (_vm$currentStep2 = _vm.currentStep) === null || _vm$currentStep2 === void 0 ? void 0 : (_vm$currentStep2$acti = _vm$currentStep2.activityImage) === null || _vm$currentStep2$acti === void 0 ? void 0 : (_vm$currentStep2$acti2 = _vm$currentStep2$acti.image) === null || _vm$currentStep2$acti2 === void 0 ? void 0 : _vm$currentStep2$acti2.src
    }
  }) : _vm._e()]), _c('div', {
    attrs: {
      "id": "steps"
    }
  }, _vm._l(_vm.currentRound.steps, function (step, stepIndex) {
    return _c('text-display-list', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: stepIndex <= _vm.progress.stepIndex,
        expression: "stepIndex <= progress.stepIndex"
      }],
      key: stepIndex,
      attrs: {
        "element": "div",
        "id": "input",
        "text-size": "small"
      }
    }, [_c('color-block-text', {
      attrs: {
        "text": step.answer,
        "text-step": stepIndex
      }
    })], 1);
  }), 1)])])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }